module.exports = __webpack_public_path__ + "img/架构.bb09693e.png";